module.exports = __webpack_public_path__ + "static/media/workforce.016797a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/SRA/workforce.png
// module id = 3538
// module chunks = 3